var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,50 C100,150 350,0 550,100 L500,00 L0,0 Z"}));
}

Wave.defaultProps = {"viewBox":"0 0 500 100","preserveAspectRatio":"xMinYMin meet"};

module.exports = Wave;

Wave.default = Wave;
